import { render, staticRenderFns } from "./followStatus.vue?vue&type=template&id=4b093a06&"
import script from "./followStatus.vue?vue&type=script&lang=js&"
export * from "./followStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports